module.exports = __webpack_public_path__ + "img/ln.f9b2def7.svg";